import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import OperationStoreCategoriesContext from "../../context/operation-store-categories/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import OperationStoreCategoriesContextProvider from "../../context/operation-store-categories/provider";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import { Permissions } from "../../utils/Permissions/Permissions";
import OperationStoreCategoriesTable from "../../components/operation-store-categories/operation-store-categories-table";

interface IProps {
  children?: React.ReactNode;
}

const OperationStoreCategories: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(OperationStoreCategoriesContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("operation_store_categories")}
        subTitle={t("operation_store_categories_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={Permissions.CAN_CREATE_OPERATION_STORE_CATEGORY}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/operation-store-categories/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_operation_store_categories")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="operation-store-categories-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        {/* <UserFilter /> */}
      </SearchFilterCard>

      <OperationStoreCategoriesTable />
    </div>
  );
};

const OperationStoreCategoriesPage = () => {
  return (
    <OperationStoreCategoriesContextProvider>
      <OperationStoreCategories />
    </OperationStoreCategoriesContextProvider>
  );
};

export default OperationStoreCategoriesPage;